module.exports = __webpack_public_path__ + "img/hot_new_icon.e4c43335.png";